const o = {
  buyLootbox: "function buyLootbox(uint256 qty)",
  getPrice: "function getPrice() view returns (uint256)",
  accountOwns: "function accountOwns(address account) view returns (uint256)",
  openLootbox: "function openLootbox(uint256 qty) external",
};

export default o;
